import * as React from "react";
import { useNavigate } from "react-router-dom";
import { TemplateSub } from "../../../components/layouts/TemplateSub";
import NewButton from "../../../components/uiMerge/newButton";

export const ConfirmTopUpLimitPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <TemplateSub page={`Confirm Transaction Limit`}>
      <div className="px-4">
        <div className="w-full mt-[3rem] flex flex-col items-center gap-[1.5rem]">
          <p className="w-full text-center text-white text-xs font-medium">
            New Transaction Limit
          </p>
          <p className="w-full h-[33px] [font-family:'Avenir-Light', 'Segoe UI', 'Arial', 'Roboto', sans-serif] flex flex-col justify-center text-center text-white text-[30px] font-extrabold">
            ₦800,000.00
          </p>
        </div>
        <div className="flex flex-col gap-[2rem]">
          <p className=" text-center text-white text-[20px] mt-[4rem] font-medium px-[4rem]">
            Input Your Pin
          </p>

          <NewButton
            fullWidth
            variant="primary"
            type="button"
            className="login-form-button"
            onClick={() => navigate("/success")}
          >
            Save Changes
          </NewButton>
        </div>
      </div>
    </TemplateSub>
  );
};